<div class="slider-zoom-container" [class.hide-slider]="(scalePercentage$ | async) === null">
    <h3 id="zoom" i18n="@@hermes.accessibility.product-images-zoom" class="sr-only">Zoom</h3>
    <button (click)="increment($event)">
        <h-svg-icon name="plus" class="close-icon"></h-svg-icon>
        <span i18n="@@hermes.accessibility.product-images-zoom-in" hSrOnlyNoSnippet>
            Zoom in, current {{ scalePercentage$ | async }}%
        </span>
    </button>

    <div #track class="track" [style.background]="trackBackground$ | async">
        <div
            #thumb
            class="thumb"
            tabindex="0"
            [style.transform]="thumbTranslate$ | async"
            [style.height.px]="thumbSize"
            [style.width.px]="thumbSize"
            [attr.role]="'slider'"
            [attr.aria-orientation]="'vertical'"
            [attr.aria-labelledby]="'zoom'"
            [attr.aria-valuenow]="scalePercentage$ | async"
            [attr.aria-valuetext]="'scale at ' + (scalePercentage$ | async) + '%'"
            [attr.aria-valuemin]="minScale"
            [attr.aria-valuemax]="maxScale"
            (mousedown)="onMouseDown($event)"
            (keydown.arrowdown)="decrement($event)"
            (keydown.arrowup)="increment($event)"></div>
    </div>

    <button (click)="decrement($event)">
        <h-svg-icon name="minus" class="close-icon"></h-svg-icon>

        <span i18n="@@hermes.accessibility.product-images-zoom-out" hSrOnlyNoSnippet>
            Zoom out, current {{ scalePercentage$ | async }}%
        </span>
    </button>
</div>
